import * as React from 'react';
import moment from 'moment';

import { DatePicker, DatePickerBaseProps } from './DatePicker';

interface StartDatePickerProps extends DatePickerBaseProps {
  minDate: moment.Moment;
}

export const StartDatePicker: React.FC<StartDatePickerProps> = (props) => {
  const { initialValue, onChange, minDate } = props;
  return (
    <DatePicker
      initialValue={initialValue}
      onChange={onChange}
      minDate={minDate}
      maxDate={moment().startOf('day')}
      errorMessage={`Invalid date; Dates must be entered in mm/dd/yyyy format and occur later than ${minDate.format(
        'MM/DD/yyyy'
      )}.`}
    />
  );
};
